import React from "react";
import { Redirect } from "react-router-dom";
import { connectPageService } from "../../../../application/domain/base/base-application-service";

import {
  ProcManagementPlaceCreateService,
  ContextProps,
} from "../../../../application/service/proc-management/place-create";
import { useAuthContextV2 } from "../../../../auth-state";
import { PortalTemplate } from "../../../template/portal/default-template";
import { ProcManagementR } from "../route";
import { Content } from "../../../organisms/proc-management/place-form";
import { isPlace } from "../../../../application/domain/proc-management";
import { TtzkPortalR } from "../../ttzk-portal/route";

const ProcManagementPlaceCreate: React.FC<ContextProps> = ({
  place,
  onChange,
  onSave,
  isUpdating,
  setOrganizationId,
}) => {
  const { auth } = useAuthContextV2();
  const orgId = auth.data?.orgId;
  React.useEffect(() => {
    if (typeof orgId === "string") {
      setOrganizationId(orgId);
    }
  }, [setOrganizationId, orgId]);

  if (isPlace(place)) {
    return (
      <Redirect
        to={ProcManagementR.PlaceDetail.link({
          placeId: place.id,
        })}
      />
    );
  }

  return (
    <PortalTemplate
      breadcrumbs={[
        { to: TtzkPortalR.Home.link({}), title: "Graffer ポータル" },
        { to: ProcManagementR.PlaceList.link({}), title: "場所マスタ" },
        { to: ProcManagementR.PlaceCreate.link({}), title: "新規作成" },
      ]}
    >
      <Content
        place={place}
        onChange={onChange}
        onPressSave={onSave}
        isUpdating={isUpdating}
      />
    </PortalTemplate>
  );
};

export const ProcManagementPlaceCreateContainer = connectPageService(
  ProcManagementPlaceCreate,
  () => new ProcManagementPlaceCreateService(),
);

export const RedirectToProcManagementPlaceCreateContainer: React.FC = () => {
  return <Redirect to={ProcManagementR.PlaceCreate.link({})} />;
};
